export default "__VITE_ASSET__BrUqcsUw__"